//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { debounce } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CollaboratorItem",
  components: {
    InlinePrompt,
    ProfileAvatar
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    allowChange: {
      type: Boolean,
      default: null
    },
    deleteOption: {
      type: Boolean,
      default: null
    },
    checked: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      labelValue: uuidv4()
    };
  },
  computed: {
    canChange() {
      var _this$allowChange;
      return (_this$allowChange = this.allowChange) != null ? _this$allowChange : this.$options.filters.isCurrentUser(this.user.username);
    }
  },
  methods: {
    handleChange: debounce(function (data) {
      if (!this.canChange) return;
      this.$emit("change", data);
    }, 150),
    handleDelete() {
      this.$emit("delete");
    }
  }
});